export interface ISwimProof {
  id: number | null;
  name: string | null;
  active: boolean | null;
}

export class SwimProof implements ISwimProof {
  id;
  name;
  active;

  constructor(config: ISwimProof) {
    this.id = config.id;
    this.name = config.name;
    this.active = config.active;
  }
}
